import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';
import { history } from './../../configuration/store';
import PaystubList from '../../components/lists/paystubs';
import { emptyPageCard } from '../../components/emptyPageCard';
import { jobHasStarted } from '../../utilities/dateTime';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PayduesList from '../../components/lists/paydues';
import { isW2 } from '../../utilities/jobStatus';

class PayStubsPage extends React.Component {
    renderW2() {
        const { role } = this.props;
        const user = role.user || this.props.user.sub;
        return (
            <div className="section">
                <PaystubList userId={user} />
            </div>
        );
    }
    renderIC() {
        const { job } = this.props;
        return (
            <div className="section">
                <PayduesList contractorId={job.contractor_id} />
            </div>
        );
    }

    render() {
        const { job, jobs } = this.props;

        const showEmptyPage = jobs.length === 0 || !job || !jobHasStarted(job);
        if (showEmptyPage) return <div className="page">{emptyPageCard(messages.pay, messages.noPayYet)}</div>;

        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{PayStubsPage.meta.label}</h4>
                    </div>
                </div>
                {isW2(job) ? this.renderW2() : this.renderIC()}
            </div>
        );
    }
}

PayStubsPage.meta = {
    label: <FormattedMessage id={'clientUploadWorkersPayStubs'} defaultMessage={'Pay'} />,
    icon: 'account_balance_wallet',
    action: () => history.push('/paystubs'),
    locations: ['/paystubs']
};

PayStubsPage.defaultProps = {
    role: {}
};

PayStubsPage.propTypes = {
    role: PropTypes.object
};

const mapStateToProps = state => ({
    role: state.identity.role,
    user: state.identity.user,
    job: state.jobs.list ? state.jobs.list.find(j => j.status === 'active' || j.status === 'inactive') : undefined,
    jobs: state.jobs.list
});

export default connect(mapStateToProps, null)(PayStubsPage);



// WEBPACK FOOTER //
// ./src/pages/paystubs/index.jsx